export const clamp = (n: number, min: number, max: number) =>
  Math.max(min, Math.min(n, max));
